import React from 'react';
import styled from '@emotion/styled';
import Segment from './Segment';

const Track = styled.div`
  display: flex;
  gap: 4px;
  width: 100%;
  box-sizing: border-box;
  padding: 4px;
  border-radius: 12px;
  background: var(--colorBlueGray1100);
  border: 1px solid var(--colorBlueGray1000);
`;

export interface SegmentOption<T extends string> {
  value: T;
  label: string;
}

interface Props<T extends string> {
  options: SegmentOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

/**
 * Pill-style switch between a few options on a dark surface, e.g. guest / company account.
 * Fills the width of its parent and splits it evenly between the options.
 */
const SegmentedControl = <T extends string>({ options, value, onChange }: Props<T>) => (
  <Track>
    {options.map((option) => (
      <Segment
        key={option.value}
        label={option.label}
        active={option.value === value}
        onSelect={() => onChange(option.value)}
      />
    ))}
  </Track>
);

export default SegmentedControl;
